import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";

export async function personalToken() {
	const ua = navigator.userAgent;
	const fp = ''+await getCurrentBrowserFingerPrint()

	return btoa(JSON.stringify({ ua, fp }))
}
